
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^(8(101|211|614)|(11|75)60|3029)$/.test(chunkId);
},
rootOutputDir: "../../",

    };
}
